import overview from './overview.vue';
import detail from './detail.vue';

export default {
    install(Vue, options) {
        Vue.component('service5', overview);
        Vue.component('detail5', detail);

        options.store.commit('addService', { "overview": "service5", "page": "detail5", "name": "Supermarkt", "id": "12345678rwer90" })
    }
}